t = require('views/internal/teacup-with-helpers')('card_in_list')
labelTemplate = require './label'
memberOnCardTemplate = require './member_on_card'

module.exports = t.renderable ({ hasStickers, labels, quickEdit, idShort, name, members, showEditor, badgesHTML }) ->
  t.div '.list-card-cover.js-card-cover'

  if showEditor
    t.icon 'edit', { class: 'list-card-operation dark-hover js-open-quick-card-editor js-card-menu' }

  t.div '.list-card-stickers-area', { class: t.classify(hide: !hasStickers) }, ->
    t.div '.stickers.js-card-stickers'

  t.div '.list-card-details', ->
    t.div '.list-card-labels.js-card-labels', ->
      for label in labels
        labelTemplate
          name: label.name
          color: label.color
          extraClasses: ['mod-card-front']
    if quickEdit
      t.textarea '.list-card-edit-title.js-edit-card-title', { dir: 'auto' }, ->
        t.text name
    else
      t.span '.list-card-title.js-card-name', { dir: 'auto' }, ->
        # guide/hacks/id-short
        if idShort
          t.span '.card-short-id.hide', ->
            t.format 'idshort', { idShort }
        t.text name
    t.div '.badges', ->
      t.span '.js-badges', ->
        t.raw badgesHTML
      t.span '.custom-field-front-badges.js-custom-field-badges'
      t.span '.js-plugin-badges'
    t.div '.list-card-members.js-list-card-members', ->
      for member in members
        memberOnCardTemplate(member)

  t.p '.list-card-dropzone', ->
    t.format 'drop-files-to-upload'

  t.p '.list-card-dropzone-limited', ->
    t.format 'too-many-attachments'

  t.p '.list-card-dropzone-restricted', ->
    t.format 'attachments-restricted'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_in_list.coffee